module.exports = __webpack_public_path__ + "Torta-ro1.png";